import { PermissionStoreModelEnum } from '@domain/permissions/permissions.enums';

interface JwtPayload {
  aud?: string;
  azp?: string;
  exp?: number;
  organization?: string[];
  preferred_username?: string;
  resource_access?: Record<string, { roles?: string[] }>;
}

export interface ImpersonationTokenClaims {
  name?: string;
  organisationId?: string;
  permissions: PermissionStoreModelEnum[];
}

const getJwtPayload = (token: string): JwtPayload | undefined => {
  try {
    const encodedPayload = token.split('.')[1];
    if (!encodedPayload) {
      return;
    }

    const json = atob(encodedPayload.replaceAll('-', '+').replaceAll('_', '/'));
    return JSON.parse(json) as JwtPayload;
  } catch {
    return;
  }
};

export const getImpersonationTokenClaims = (token: string): ImpersonationTokenClaims | undefined => {
  const payload = getJwtPayload(token);
  if (!payload || (payload.exp !== undefined && payload.exp * 1000 <= Date.now())) {
    return;
  }

  return {
    name: payload.preferred_username,
    organisationId: payload.organization?.[0],
    permissions:
      ((payload.aud ? payload.resource_access?.[payload.aud]?.roles : undefined) as PermissionStoreModelEnum[] | undefined) ?? [],
  };
};
